(() => {
  const gallerySelector = 'product-images[data-zyvoria-gallery-autoplay]';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initializeGallery = (gallery) => {
    if (gallery.dataset.zyvoriaAutoplayReady === 'true') return;
    gallery.dataset.zyvoriaAutoplayReady = 'true';

    const rail = gallery.querySelector('.product__slides');
    if (!rail) return;

    const interval = Number(gallery.dataset.autoplayInterval) || 5000;
    let pausedUntil = 0;
    let timer;

    const visibleSlides = () => [...rail.querySelectorAll(':scope > .product__slide:not([hidden])')];

    const activeIndex = () => {
      const slides = visibleSlides();
      const activeMedia = gallery.getAttribute('data-active-media');
      const selectedIndex = slides.findIndex(
        (slide) => slide.getAttribute('data-media-id') === activeMedia,
      );
      if (selectedIndex >= 0) return selectedIndex;

      const railLeft = rail.getBoundingClientRect().left;
      return slides.reduce((closest, slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - railLeft);
        return distance < closest.distance ? { index, distance } : closest;
      }, { index: 0, distance: Infinity }).index;
    };

    const moveTo = (slide) => {
      if (gallery.hasAttribute('data-fader-mobile')) {
        gallery.dispatchEvent(new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: {id: slide.getAttribute('data-media-id')},
        }));
        return;
      }

      const railLeft = rail.getBoundingClientRect().left;
      const target = slide.getBoundingClientRect().left - railLeft + rail.scrollLeft;
      rail.scrollTo({ left: target, behavior: 'smooth' });
    };

    const advance = () => {
      const slides = visibleSlides();
      if (
        slides.length < 2
        ||
        !mobileQuery.matches
        || reducedMotionQuery.matches
        || document.hidden
        || Date.now() < pausedUntil
      ) {
        return;
      }

      const nextIndex = (activeIndex() + 1) % slides.length;
      moveTo(slides[nextIndex]);
    };

    const restart = () => {
      window.clearInterval(timer);
      timer = window.setInterval(advance, interval);
    };

    const pauseForInteraction = () => {
      pausedUntil = Date.now() + 13000;
    };

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((eventName) => {
      gallery.addEventListener(eventName, pauseForInteraction, { passive: eventName !== 'keydown' });
    });

    mobileQuery.addEventListener('change', restart);
    reducedMotionQuery.addEventListener('change', restart);
    restart();
  };

  const initialize = (root = document) => {
    root.querySelectorAll(gallerySelector).forEach(initializeGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
